import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyBillWave,
  faClock,
  faTimesCircle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";

const InvoiceSummaryCards = ({ summary, timeFilter }) => {
  const timeLabel =
    timeFilter === "yearly"
      ? "Yearly"
      : timeFilter === "monthly"
      ? "Monthly"
      : timeFilter === "weekly"
      ? "Weekly"
      : timeFilter === "daily"
      ? "Daily"
      : "All time";

  const cards = [
    {
      title: "Total Revenue",
      value: `₦${summary.totalRevenue}`,
      sub: `${timeLabel} • loaded purchases`,
      icon: faMoneyBillWave,
      gradient: "from-emerald-500 to-emerald-700",
      textColor: "text-emerald-100",
      subColor: "text-emerald-200",
    },
    {
      title: "Successful",
      value: summary.totalSuccessfulInvoices,
      sub: `₦${summary.totalRevenue} total`,
      icon: faCheckCircle,
      gradient: "from-sky-500 to-sky-700",
      textColor: "text-sky-100",
      subColor: "text-sky-200",
    },
    {
      title: "Pending",
      value: summary.totalPendingInvoices,
      sub: `₦${summary.totalPendingAmount} total`,
      icon: faClock,
      gradient: "from-amber-500 to-amber-700",
      textColor: "text-amber-100",
      subColor: "text-amber-200",
    },
    {
      title: "Failed",
      value: summary.totalFailedInvoices,
      sub: `₦${summary.totalFailedAmount} total`,
      icon: faTimesCircle,
      gradient: "from-red-500 to-red-700",
      textColor: "text-red-100",
      subColor: "text-red-200",
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.title}
          className={`relative overflow-hidden rounded-xl bg-gradient-to-br ${card.gradient} p-5 shadow-lg`}
        >
          <div className="absolute -right-4 -top-4 h-24 w-24 rounded-full bg-white/10" />
          <div className="absolute -bottom-4 -left-4 h-16 w-16 rounded-full bg-white/10" />
          <div className="relative z-10 flex items-start justify-between">
            <div className="flex-1">
              <p className={`mb-1 text-xs font-semibold uppercase tracking-wider ${card.textColor}`}>
                {card.title}
              </p>
              <h3 className="mb-1 text-2xl font-bold text-white">{card.value}</h3>
              <p className={`text-xs font-medium ${card.subColor}`}>{card.sub}</p>
            </div>
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/20 backdrop-blur-sm">
              <FontAwesomeIcon icon={card.icon} className="text-xl text-white" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InvoiceSummaryCards;